export const environment = {
    production: false,
    apiUrl: 'https://ferienspiele-dev.api.lptzocker.com/'
};